<template>
  <template v-if="inclFB">PanelFaena.vue: template beg<br></template>
  <template v-if="inclFB">PanelFaena.vue: f={{ f }}.<br></template>
    <div class="bg-white">
 
        <div class="p-1 bg-white">
              <div class="flex items-center">
                <div class="flex-shrink-0"></div>
                <div class="ml-5 flex-1 text-left">
                  <dl>
                    <dt class="font-semibold    text-cyan-900 pl-0 h-10 p-2 ">
                      {{ f.nombre }} 
                    </dt>
                   
                    <dt class="font-semibold  text-xs   text-cyan-500 pl-0  ">
                      {{ $t(f.descripcion) }}
                    </dt>

                    <template v-if="inclFB">PanelFaena.vue: centerSummary={{ centerSummary }}.<br></template>

                    <dd class="mt-2 text-xs pr-4">
                      <ConsumoOxigeno v-if="seriesO2Loaded === true" :idFaena="f.id" :consumo_oxigeno="f.consumo_o2"
                        :seriesFaenas="seriesFaenas" :consOxig="consumption">
                      </ConsumoOxigeno>
                    </dd>

                    <dd class="mt-2 text-xs">
                      <span class="font-semibold ">{{$t('modos_operacion')}}</span>
                      <div class="flex">
                        <!-- Primera columna: Ocupa el 30% del ancho del contenedor -->
                        <div class="pl-0 w-1/3">
                          <!--                          
                          <ModosOperacionMensual v-if="seriesLoaded === true" :idFaena="f.id" :mensual="f.modos_op">
                          </ModosOperacionMensual>
                          -->
                          <template v-if="inclFB">
                            PanelFaena.vue: f.id={{ f.id }}, f.modos_op={{ f.modos_op }}, modos_operacion= {{ modos_operacion }}.<br>
                          </template>
                          <ModosOperacionMensual :idFaena="f.id" :mensual="f.modos_op" :modOpe="modos_operacion">
                          </ModosOperacionMensual>
                        </div>

                        <!-- Segunda columna: Ocupa el ancho restante -->
                        <div class="flex-1">
                        
                          <!-- <FaenaDonut  :idFaena="f.id" :mensual="f.modos_op"></FaenaDonut> -->
                          <FaenaDonut :idFaena="f.id" :mensual="f.modos_op" :modOpe="modos_operacion">
                          </FaenaDonut>

                        </div>
                      </div>

                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-0 py-3">
              <div class="text-sm">

                <a @click="loadHistorial(f)"
                  class="cursor-pointer w-18 h-10 mt-2 mb-2 ml-1 mr-1 inline-block rounded-lg  px-4   py-2 bg-purple-900 text-base font-semibold leading-7 text-white    ">

                  <div class="flex items-center">
                    <div style="height:22px;width:8px"></div>
                    <div class="ml-0 pr-1">{{ $t('historial') }}</div>

                  </div>

                </a>
                <a @click="loadCentros(f)"
                  class="cursor-pointer w-18 h-10  mt-2 mb-2 ml-1 mr-1  inline-block rounded-lg  px-4   py-2 bg-gray-700  text-base font-semibold leading-7 text-white    ">

                  <div class="flex items-center">
                    <div style="height:22px;width:25px"><img src="../../assets/barchart.gif" height="22"></div>
                    <div class="ml-2">Live</div>

                  </div>

                </a>

              </div>
            </div>
    </div>
  <template v-if="inclFB">PanelFaena.vue: template end<br></template>
</template>

<script>
//import axios from "axios";

import FaenaDonut from "./FaenaDonut";
import ConsumoOxigeno from "./ConsumoOxigeno";
import ModosOperacionMensual from "./ModosOperacionMensual"; 
//import AuthHeader  from "@/services/auth.header";
import axios from "axios";
export default {
  name: "FaenasCliente",
  props: ["f"],
  emits: ['chgFaena', 'chgFaenaCentros', 'sendDivisionesMenuLat'],
  components: {
    FaenaDonut,
    ModosOperacionMensual,
    ConsumoOxigeno,
  },
  data() {
    return {
      nick: 'PanelFaena.vue',
      idFaena: this.f.id,
      fechasSeleccionadas: ['01 11 2023', '30 11 2023'],
      mostrar: false,
      showModalMapa: false,
      showModalAyuda: false,
      seriesLoaded: false,
      seriesO2Loaded: false,
      showPanelAyuda: false,
      datos_mensuales: [],
      faenas: [{}],
      cards: [{}],
      objFaenas: [{}],
      seriesFaenas: [],
      seriesFechas: [],
      nomMes: ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      seriesMedicionesOxigeno1: [],
      seriesMedicionesOzono1: [],
      inclFB: false,
      modos_operacion: [],
      modos_operacion_debug: [],
      centerSummary: {},
      consumption: {}
    };
  },
  methods: {
     
    loadDataSesion() {
      this.faenas = this.$store.state.login.userLogin.info.faenas;
    },


    enviaDivisionesMenuLat() {

      this.$emit("sendDivisionesMenuLat", this.faenas);
    },
    loadMapa() {
      //console.log('LOAD MAPA')
      this.showModalMapa = true
    },
    closeModal() {
      this.showModalMapa = false
    },
    loadDivisiones(f) {

      this.$emit("chgFaena", f);
    },
    loadCentros(f) {

      this.$emit("chgFaenaCentros", f);
    },
    loadHistorial(f) {

      this.$emit("chgHistorialCentros", f);
    },
    getFecCalendar(f) {

      //  //console.log('calendario', f);
      /* [ "01 10 2023",   "31 10 2023"]   */

      if (f[0] == '' || f[1] == '') return false;


      const startDate = this.convertirFormatoFecha(f[0])
      const endDate = this.convertirFormatoFecha(f[1])
      this.seriesFechas = this.$store.getters.generaSerieFechas(startDate, endDate)

      this.seriesMedicionesOxigeno1 = this.manipulaSeriesFechas(4, 6)
      this.seriesMedicionesOxigeno2 = this.manipulaSeriesFechas(6, 8)
      this.seriesMedicionesOzono1 = this.manipulaSeriesFechas(100, 300)
      this.seriesMedicionesOzono2 = this.manipulaSeriesFechas(300, 700)
      this.mostrar = true

    },

    manipulaSeriesFechas(min, max) {
      let dataFaena = []
      /*
       seriesFechas
       *[ "2023-10-01".."2023-10-31"]*/
      for (let x = 0; x < this.faenas.length; x++) {

        let data = []
        for (let i = 0; i < this.seriesFechas.length; i++) {

          let dma = this.convertirFormatoFechaDMA(this.seriesFechas[i])
         // //console.log(dma)

          let f = Date.parse(dma + ' 00:00:00 GMT')
          let n = parseFloat(this.getRnd(min, max));
          data.push([f, n])

          f = Date.parse(dma + ' 04:00:00 GMT')
          n = parseFloat(this.getRnd(min, max));
          data.push([f, n])

          f = Date.parse(dma + ' 08:00:00 GMT')
          n = parseFloat(this.getRnd(min, max));
          data.push([f, n])

          f = Date.parse(dma + ' 12:00:00 GMT')
          n = parseFloat(this.getRnd(min, max));
          data.push([f, n])

          f = Date.parse(dma + ' 16:00:00 GMT')
          n = parseFloat(this.getRnd(min, max));
          data.push([f, n])

          f = Date.parse(dma + ' 20:00:00 GMT')
          n = parseFloat(this.getRnd(min, max));
          data.push([f, n])

        }
        let medicion = { name: this.faenas[x].nombre, data: data }
        dataFaena.push(medicion)

      }
      return dataFaena;

      //this.chartOptions.series  = dataFaena

    },
    

    convertirFormatoFecha(fechaOriginal) {

         if (!fechaOriginal) return null;
      const [dia, mes, año] = fechaOriginal.split(" ");
      return (dia && mes && año) ? `${año}-${mes}-${dia}` : null;

    
    },

    convertirFormatoFechaDMA(fechaOriginal) {
      try {
        const partes = fechaOriginal.split("-");
        if (partes.length === 3) {
          const dia = partes[0];
          const mes = this.nomMes[Number(partes[1])];
          const año = partes[2];
          const nuevaFecha = `${año} ${mes} ${dia}`;
          return nuevaFecha;
        }
      } catch (error) {
        //console.log(error)
      }
      return null;
    },

    getRnd(min, max) {
      let flot = Math.random() * (max - min + 1) + min;

      return flot.toFixed(2)
    },
    showModalHelp() {
      //console.log("show modal");
      this.showModal = true;
    },
    handleDragOVer(event){
      //console.log('over')
      event.preventDefault()
    },  
    handleDragEnter(event){
      console.error('enter', event)
    },
     handleDrop(){
      //console.log('DROP FAENA')
     
    },
    async getOperatingModes() {
      console.log(this.nick, '>>', "getOperatingModes: starting");
      try {
        const apiKey = this.$store.state.login.tokenLogin;
        const objStoreFaenas = this.$store.state.faenas;
        console.log(this.nick, '>>', 'objStoreFaenas>', objStoreFaenas);
        let arrayFaenas = [];
        console.log(this.nick, '>>', 'this.idFaena: ', this.idFaena);
        this.objFaena = objStoreFaenas.faenas.filter(faena => faena.id == this.idFaena);
        console.log(this.nick, '>>', 'this.objFaena:', this.objFaena);
        arrayFaenas = this.objFaena;
        console.log(this.nick, '>>', 'arrayFaenas:', arrayFaenas);
        // Se creará una promesa por cada elemento de arrayFaenas, aunque lo normal es que haya solamente 1 elemento.
        const centerPromises = arrayFaenas.map((faena) => {
          this.glosaDataType = false;
          if (faena.id !== undefined) {
            const requestData = {
              idCenter: this.idFaena
            };
            return axios
              .post("/api/ctl/getCenterOperatingModes", requestData, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `${apiKey}`
                }
              })
              .then((response) => {
                this.glosaDataType = response.data.payload.dataType == 'dummy' ? true : false;
                let opmodes = response.data.payload.opmodes;
                this.modos_operacion = Object.values(opmodes);
                this.seriesLoaded=true;
                // Resultado: [18, 0, 0, 0, 82]
                console.log(this.nick, '>>', 'idFaena:', this.idFaena, 'modos_operacion:', this.modos_operacion);
                this.modos_operacion_debug = Object.entries(opmodes).map( ([modo, valor]) => ({ modo, valor }) );
                // Resultado: [
                //   { modo: "standard", valor: 18 },
                //   { modo: "eco", valor: 0 },
                //   { modo: "maxload", valor: 0 },
                //   { modo: "aire", valor: 0 },
                //   { modo: "standby", valor: 82 }
                // ]
                console.log(this.nick , '>>', 'idFaena:', this.idFaena, 'modos_operacion_debug:', this.modos_operacion_debug);
              })
              .catch((error) => {
                console.log(this.nick, '>>', "Error al obtener datos del centro desde PanelFaena.vue", error);
                return [];
              })
          }
          else
          {
            console.log(this.nick, '>>', '(is idFaena defined?) idFaena:', this.idFaena);
          }
        });
        await Promise.all(centerPromises);
      } catch (error) {
        console.log("PanelFaena.vue: error procesando faenas en PanelFaena.vue", error);
      }
      console.log(this.nick, '>>', 'getOperatingModes: end.');
    },
    setOperatingModes()
    {
      // Para publicidad: beg.
      if (this.idFaena===1001) this.modos_operacion=[67,0,0,5,28];
      if (this.idFaena===1002) this.modos_operacion=[17,0,0,12,71];
      // Para publicidad: end.
    },
    getSummaryAndSetAll() {

      // centerSummary:
      let cS=this.f.summary;
      // For this PanelFaena component log:
      this.centerSummary=cS;
      // For ConsumoOxigeno component:
      this.consumption={"beg": cS.startDay, "day": cS.dayConsumption, "mon": cS.monthConsumption, "per": cS.periodConsumption};
      // For ModosOPeracionMensual and FaenaDonut components:
      this.modos_operacion=[cS.standardOperation, cS.ecoOperation, cS.maxloadOperation, cS.aireOperation, cS.standbyOperation];

    },
    async cargarDatos() {
      console.log(this.nick, '>>', 'cargarDatos(): todo await this.getOperatingModes()');
      // await this.getOperatingModes(); // Para explotación lenta
      // await this.setOperatingModes(); // Para publicidad
      await this.getSummaryAndSetAll(); // Para explotación rápida
      console.log(this.nick, '>>', 'cargarDatos(): done await this.getOperatingModes()');
    }
  },
  computed: {

  },
  mounted() {
    this.datos_mensuales = [60, 20, 10, 10, 0];
    // this.loadData();
    this.loadDataSesion();
    this.enviaDivisionesMenuLat();
    this.seriesO2Loaded = true;
    this.getFecCalendar(this.fechasSeleccionadas);
    this.cargarDatos();
//    this.seriesLoaded = true;
  },
};
</script>
